import { addListener } from "@grindex-common/helpers/domManipulation";

class Route {
	// Add a tabChanged callback to options if you want your tabs-view
	// to respond to changes to url, i: e user clicks back or forward
	// Sample of this exists in xyl.views.product-tabs.js
	constructor(options) {
		this.routes = {};

		// root should not contain segments
		this.root = "/";
		if (options.root) {
			this.root = options.root;
		}
		if (options.router) {
			this.routes = options.router;
		}

		if (options.tabChanged) {
			this.tabChanged = options.tabChanged;
		}

		addListener(window, "popstate", () => {
			if (this.tabChanged) {
				const currentTabName = this.getCurrentSegment();
				this.tabChanged(currentTabName);
			}
		});
	}

	clearSlashes(path) {
		return path.toString().replace(/\/$/, "").replace(/^\//, "");
	}

	getCurrentSegment() {
		const urlwithNoSegment = this.root;
		const currentUrl = this.clearSlashes(window.location.pathname);
		const segment = this.clearSlashes(currentUrl.substr(urlwithNoSegment.length - 1, currentUrl.length));

		if (segment === "") {
			return this.routes["/"];
		} else {
			return segment;
		}
	}

	getRoute(val) {
		for (let route in this.routes) {
			if (this.routes[route] === val) {
				return route;
			}
		}
	}

	navigate(segment) {
		window.history.pushState(null, null, this.root.replace(/\/$/, "") + this.getRoute(segment) + window.location.search);
	}
}

export { Route };
